
export default {
  UPDATE_KAS_FILTER (state, filter) {
    state.tranksaksiFilter = filter
  },
  SET_NULL_TASKS (state) {
    state.tranksaksis = []
  },
  SET_NULL_PEMBAYARAN (state) {
    state.pembayarans = []
  },
  SET_RANGE (state, range) {
    state.state_range = range
  },

  // TASK
    SET_TASKS (state, tranksaksis) {
      state.tranksaksis = tranksaksis
    },
    SET_TOTALS (state, payload) {
      state.total = payload
    },
    SET_LAST (state, payload) {
      state.last = payload
    },
    SET_PER_PAGE (state, payload) {
      state.per_page = payload
    },
    SET_CURRENT_PAGE (state, payload) {
      state.current_page = payload
    },
    SET_MAX_RANGE (state, payload) {
      state.max_range = payload
    },
    ADD_UPDATE (state, item) {
      state.tranksaksis.unshift(item)
    },
    EDIT_UPDATE (state, item) {
      const tranksaksiIndex = state.tranksaksis.findIndex((p) => p.id === item.task_parent)
      Object.assign(state.tranksaksis[tranksaksiIndex], item)
    },
    REMOVE_TRANKSAKSI (state, id) {
      const ItemIndex = state.tranksaksis.findIndex((p) => p.id === id)
      state.tranksaksis.splice(ItemIndex, 1)
    },

  // KATEGORI
    SET_KATEGORIS (state, tags) {
      state.tranksaksiKategoris = tags
    },
    ADD_KATEGORI (state, item) {
      state.tranksaksiKategoris.push(item)
    },

  // TAG
    SET_TAGS (state, tags) {
      state.tranksaksiTags = tags
    },
    ADD_TAG (state, item) {
      state.tranksaksiTags.push(item)
    },
    UPDATE_TAGS (state, payload) {
      state.tranksaksis.find((tranksaksi) => tranksaksi.id === payload.id).tags = payload.tags
    },

  // PEMBAYARAN
    SET_PEMBAYARAN (state, data) {
      state.pembayarans = data
    },
    SET_PEMBAYARAN_SISA (state, data) {
      state.pembayaran_sisa = data
    },
    SET_PEMBAYARAN_TOTAL (state, data) {
      state.pembayaran_total = data
    },
    SET_PEMBAYARAN_STATUS (state, data) {
      state.pembayaran_status = data
    },
    ADD_UPDATE_PEMBAYARAN (state, item) {
      state.pembayarans.unshift(item.pembayaran)
      state.pembayaran_sisa = state.pembayaran_sisa - item.pembayaran.task_total
      state.pembayaran_status = item.pembayaran_status
      state.tranksaksis.find((tranksaksi) => tranksaksi.id === parseInt(item.pembayaran.task_group)).status_lunas = item.pembayaran_status
    },
    EDIT_UPDATE_PEMBAYARAN (state, item) {
      const tranksaksiIndex = state.pembayarans.findIndex((p) => p.id === item.pembayaran.id)
      Object.assign(state.pembayarans[tranksaksiIndex], item.pembayaran)
      let total = state.tranksaksis.find((tranksaksi) => tranksaksi.id === parseInt(item.pembayaran.task_group)).task_total
      state.pembayaran_sisa = total - item.pembayaran.task_total
      state.pembayaran_status = item.pembayaran_status
      state.tranksaksis.find((tranksaksi) => tranksaksi.id === parseInt(item.pembayaran.task_group)).status_lunas = item.pembayaran_status
    },
    REMOVE_PEMBAYARAN (state, item) {
      const ItemIndex = state.pembayarans.findIndex((p) => p.id ===  parseInt(item.id))
      state.pembayarans.splice(ItemIndex, 1)
      state.tranksaksis.find((tranksaksi) => tranksaksi.id === parseInt(item.task_group)).status_lunas = item.pembayaran_status
      state.pembayaran_sisa = item.pembayaran_sisa
    },
    RESTORE_PEMBAYARAN (state, item) {
      const ItemIndex = state.pembayarans.findIndex((p) => p.id ===  parseInt(item.pembayaran.id))
      state.pembayarans.splice(ItemIndex, 1)
      state.tranksaksis.find((tranksaksi) => tranksaksi.id === parseInt(item.pembayaran.task_group)).status_lunas = item.pembayaran_status
      state.pembayaran_sisa = item.pembayaran_sisa
    }

}
